<template>
  <i
      @click="showPop = !showPop"
      :class="{
      color: modelValue || loopKey || bindParam?.key,
      white: white || editorType === 1,
    }"
      :style="{'color': '#008aff'}"
      class="cursor font-weight iconfont icon-bind ml-4"
      title="绑定变量，绑定值优先级高于输入值,仅运行态生效"
  ></i>
  <!-- 强改变量绑定色值为蓝色，黑白都能显示，临时解决配色不生效问题 -->
  <el-dialog
      v-model="showPop"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      @opened="selectNode"
      draggable
      title="数据绑定"
      width="400px"
  >
    <div style="height: 300px" class="pb-30 pos-r">
      <!--			<div class="flex" style="justify-content: flex-end">-->
      <!--				<el-link style="font-size: 20px" :icon="Close" :underline="false" class="close-btn" type="primary" @click="showPop = false"></el-link>-->
      <!--			</div>-->
      <div class="hp100 overflow">
        <el-tabs
            v-model="tab"
            tab-position="left"
            class="demo-tabs hp100 self-tabs"
        >
          <el-tab-pane name="2" label="联动数据">
            <div class="overflow" style="height: 260px">
              <el-tree
                  ref="tree2"
                  :data="linkTreeData"
                  default-expand-all
                  highlight-current
                  node-key="key"
                  @node-click="
                    (data, node) => {
                      handleBigNodeClick(data, node);
                    }
                  "
              >
                <template v-slot:default="{ node, data }">
                  <div class="flex between wp100">
                    <div class="text xs">
                      {{ data.name }}
                    </div>
                    <!--                      <el-tag class="ml-2" :type="getType(data.fieldType)">{{ getLabel(data.fieldType) }}</el-tag>-->
                  </div>
                </template>
              </el-tree>
            </div>
          </el-tab-pane>
          <template v-if="editorType !== 1">
            <el-tab-pane name="1" label="数据源">
              <div class="overflow" style="height: 260px">
                <el-tree
                    ref="tree"
                    :data="datas"
                    default-expand-all
                    highlight-current
                    node-key="key"
                    @node-click="
                    (data, node) => {
                      handleNodeClick(data, node);
                    }
                  "
                >
                  <template v-slot:default="{ node, data }">
                    <div class="flex between wp100">
                      <div class="text xs">
                        {{ data.label }}
                      </div>
                      <el-tag class="ml-2" :type="getType(data.type)">{{
                          getLabel(data.type)
                        }}
                      </el-tag>
                    </div>
                  </template>
                </el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane
                v-if="showLoop && editorType !== 1"
                name="25"
                label="循环变量"
            >
              <el-input
                  v-model="loopKeyModel"
                  type="textarea"
                  autosize
              ></el-input>
            </el-tab-pane>
          </template>
          <el-tab-pane name="4" label="计算变量">
            <div class="overflow" style="height: 260px">
              <el-tree
                  ref="tree4"
                  :data="computedDatas"
                  default-expand-all
                  highlight-current
                  node-key="key"
                  @node-click="
                  (data, node) => {
                    handleComputedNodeClick(data, node);
                  }
                "
              >
                <template v-slot:default="{ node, data }">
                  <div class="flex between wp100">
                    <div class="text xs">
                      {{ data.label }}
                    </div>
                    <el-tag class="ml-2" :type="getType(data.type)">{{
                        getLabel(data.type)
                      }}
                    </el-tag>
                  </div>
                </template>
              </el-tree>
            </div>
          </el-tab-pane>
          <!--				先默认显示页面入参吧 	v-if="showPageParam"-->
          <el-tab-pane name="3" label="页面入参">
            <el-tree
                ref="tree3"
                :data="pageParam"
                default-expand-all
                highlight-current
                node-key="fieldKey"
                @node-click="
                (data, node) => {
                  handlePageParamNodeClick(data, node);
                }
              "
            >
              <template v-slot:default="{ node, data }">
                <div class="flex between wp100">
                  <div class="text xs">
                    {{ data.fieldName }}
                  </div>
                  <el-tag class="ml-2" :type="getType(data.fieldType)">{{
                      getLabel(data.fieldType)
                    }}
                  </el-tag>
                </div>
              </template>
            </el-tree>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="tac pos-a" style="bottom: 4px; left: 40%">
        <el-link
            :icon="Delete"
            type="primary"
            class="fs-12"
            :underline="false"
            @click="removeBind"
        >移除绑定
        </el-link
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {computed, inject, nextTick, ref} from "vue";
import {Delete} from "@element-plus/icons-vue";
import {Close} from "@element-plus/icons-vue";
import {PARAM_TYPE} from "@/option/common/dict.js";

let props = defineProps({
  modelValue: {},
  loopKey: {},
  white: {
    type: Boolean,
  },
  showLoop: {
    type: Boolean,
    default: false,
  },
  bindParam: {},
  // 是否显示绑定页面入参
  showPageParam: {
    type: Boolean,
    default: false,
  },
  linkData: {},
});
let showPop = ref(false);
let emit = defineEmits([
  "update:modelValue",
  "update:loopKey",
  "update:bindParam",
]);
let getApp = inject("getApp", null);
let app = getApp ? getApp() : inject("app");
let pageConfig = inject("pageConfig", {});
let editorType = inject("editorType");
let linkTreeData = computed(() => {
  let res = [];
  for (const resKey in props?.linkData ?? {}) {
    let el = props.linkData[resKey];
    res.push({
      key: resKey,
      name: el.name,
      children: getChildren(el, resKey),
    });
  }
  return res;
});

// 对联动数据的key使用组件id.code拼接来保证key字段的唯一值，element-ui文档明确，key是每个树节点用来作为唯一标识的属性，key在整棵树应该是唯一的
function getChildren(item, resKey) {
  let res = [];
  let all = item;
  for (const allKey in all) {
    let el = all[allKey];
    if (allKey !== "name") {
      res.push({
        ...el,
        key: `${resKey}.${el.code}`,
      });
    }
  }
  return res;
}

let datas = computed(() => {
  return pageConfig?.value?.schemaJson?.datas;
});
let computedDatas = computed(() => {
  return pageConfig?.value?.schemaJson?.computed;
});
let tree = ref();
let tree2 = ref();
let tree3 = ref();
let tree4 = ref();
let tab = ref("1");
let loopKeyModel = computed({
  get() {
    return props.bindParam?.key || "";
  },
  set(v) {
    // 新版
    emit("update:bindParam", {
      type: PARAM_TYPE.LOOP,
      key: v,
    });
    // 兼容老版本只有一个key 但已不满足部分需求 无可奈何 所以扩展为绑定对象 别喷我哦
    // emit("update:loopKey", v);
  },
});
if (props.loopKey) {
  tab.value = "2";
}
let pageParam = computed(() => {
  if (Array.isArray(app.pageParams)) {
    return app.pageParams;
  }
  return [];
});

function getType(type) {
  switch (type) {
    case "number":
      return "";
    case "boolean":
      return "success";
    case "date":
      return "info";
    case "string":
      return "warning";
    case "object":
    case "array":
      return "danger";
    default:
      return "";
  }
}

function getLabel(type) {
  switch (type) {
    case "number":
      return "数字";
    case "string":
      return "字符串";
    case "date":
      return "日期";
    case "boolean":
      return "布尔";
    case "object":
      return "对象";
    case "array":
      return "数组";
    default:
      return "";
  }
}

function handleBigNodeClick(data, node) {
  let key = data.key;
  // 在联动数据的树数据处理的时候key值本身已经处理成了key.code拼接模式，因此注释掉如下代码2024.4.7
  // key += getParentKey(node);
  // 对key进行reverse 因为选择是从子到父遍历 获取的时候需要从父到子
  // key = key.split(".").reverse().join(".");
  emit("update:modelValue", key);
  emit("update:bindParam", {
    type: PARAM_TYPE.LINK,
    key: key,
  });
  showPop.value = false;
}

function handleNodeClick(data, node) {
  let key = data.key;
  key += getParentKey(node);
  // 对key进行reverse 因为选择是从子到父遍历 获取的时候需要从父到子
  key = key.split(".").reverse().join(".");
  console.log(key);
  emit("update:modelValue", key);
  emit("update:bindParam", {
    type: PARAM_TYPE.VARIABLE,
    key: key,
  });
  showPop.value = false;
}

function handleComputedNodeClick(data, node) {
  let key = data.key;
  key += getParentKey(node);
  // 对key进行reverse 因为选择是从子到父遍历 获取的时候需要从父到子
  key = key.split(".").reverse().join(".");
  console.log(key);
  emit("update:bindParam", {
    type: PARAM_TYPE.COMPUTED,
    key: key,
  });
  showPop.value = false;
}

function handlePageParamNodeClick(data, node) {
  emit("update:bindParam", {
    type: PARAM_TYPE.PAGE,
    key: data.fieldKey,
  });
  emit("update:modelValue", data.fieldKey);
  showPop.value = false;
}

function getParentKey(node) {
  if (!node.parent) return "";
  if (node.parent.data.key) {
    return `.${node.parent.data.key}` + getParentKey(node.parent);
  } else {
    return "";
  }
}

function selectNode() {
  if (props.bindParam) {
    let keys = props.bindParam.key?.split(".");
    if (props.bindParam.type === PARAM_TYPE.PAGE) {
      tab.value = "3";
      nextTick(() => {
        tree3.value.setCurrentKey(keys[keys.length - 1]);
      });
    } else if (props.bindParam.type === PARAM_TYPE.LINK) {
      tab.value = "2";
      nextTick(() => {
        // 联动数据树形组件的数据key值已自动拼接，可直接使用key字段
        tree2.value.setCurrentKey(props.bindParam.key)
      });
    } else if (props.bindParam.type === PARAM_TYPE.VARIABLE) {
      tab.value = "1";
      nextTick(() => {
        tree.value.setCurrentKey(keys[keys.length - 1]);
      });
    } else if (props.bindParam.type === PARAM_TYPE.COMPUTED) {
      tab.value = "4";
      nextTick(() => {
        tree4.value.setCurrentKey(keys[keys.length - 1]);
      });
    }
    //   兼容老版数据格式 只绑定一个key不太对 需要绑定个对象
  } else if (props.modelValue) {
    let keys = props.modelValue?.split(".");
    tree.value.setCurrentKey(keys[keys.length - 1]);
  }
}

function removeBind() {
  emit("update:modelValue", "");
  emit("update:loopKey", "");
  emit("update:bindParam", null);
  tree.value.setCurrentKey(null);
}
</script>
<style scoped lang="scss">
:deep(.self-tabs .el-tabs__nav) {
  width: 78px;
}

:deep(.el-tree-node > .el-tree-node__children) {
  overflow: auto;
}

//.color{
//  color: var(--el-color-primary);
//}
//.white {
//	color: #fff;
//
//	&.color {
//		color: $primaryColor;
//	}
//}
</style>
<style lang="scss">
html {
  .white {
    color: #fff;
  }
}
</style>
